import { Tooltip } from "@mui/material";
import { NeutralColor, SemanticColor } from "node-library/dist/colors";

interface SimpleTooltipProps {
	id: string;
	description: string;
	arrow?: boolean;
	placement?:
		| "bottom-end"
		| "bottom-start"
		| "bottom"
		| "left-end"
		| "left-start"
		| "left"
		| "right-end"
		| "right-start"
		| "right"
		| "top-end"
		| "top-start"
		| "top"
		| undefined;
}

function SimpleTooltip(props: SimpleTooltipProps): JSX.Element {
	return (
		<Tooltip
			title={props.description}
			arrow={props.arrow}
			placement={props.placement}
			PopperProps={{
				sx: {
					"& .MuiTooltip-tooltip": {
						backgroundColor: NeutralColor.NEUTRAL_GREY_950,
					},
				},
			}}
		>
			<div
				style={{
					color: SemanticColor.INFO_MEDIUM,
					width: "16px",
					height: "16px",
					border: `1px solid ${SemanticColor.INFO_MEDIUM}`,
					borderRadius: "50%",
					cursor: "pointer",
					textAlign: "center",
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					fontSize: "12px",
				}}
				onMouseEnter={(e) => {
					e.currentTarget.style.backgroundColor = SemanticColor.INFO_MEDIUM; // Change background on hover
					e.currentTarget.style.color = "white"; // Change text color on hover
				}}
				onMouseLeave={(e) => {
					e.currentTarget.style.backgroundColor = "transparent"; // Revert background
					e.currentTarget.style.color = SemanticColor.INFO_MEDIUM; // Revert text color
				}}
			>
				i
			</div>
		</Tooltip>
	);
}

export { SimpleTooltip };
